let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aeVRN")).then(() => parcelRequire('3MoTL'));